import {NgModule} from "@angular/core";
import {AppRouterComponent} from "./app-router.component";
import {BrowserModule} from "@angular/platform-browser";
import {AppRoutingModule} from "./app.routing.module";
import {APP_CONFIG, AppConfig} from "./config/app.config";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "./config/hotel-tours-list-page.config";
import {HttpClientModule} from "@angular/common/http";
import {WindowRefService} from "./services/window-ref.service";
import {AppRouterErrorsComponent} from "./router-components/errors/router-errors.component";
import {SkeletonCardComponent} from "./pages/avia/avia-card/avia-card-skeleton/avia-card-skeleton.component";
import {SearchProgressLinearComponent} from "./components/search-progress-linear/search-progress-linear.component";
import {PageTitleComponent} from "./router-components/page-title/page-title.component";

@NgModule({
  providers: [
    {provide: APP_CONFIG, useClass: AppConfig},
    {provide: HOTEL_TOURS_PAGE_CONFIG, useClass: HotelToursPageConfig},
    WindowRefService
  ],
  exports: [
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AppRouterErrorsComponent,
    SkeletonCardComponent,
    SearchProgressLinearComponent,
    PageTitleComponent
  ],
  declarations: [
    AppRouterComponent,
  ],
  bootstrap: [
    AppRouterComponent
  ],
})
export class AppRouterModule {}
